import { createFileRoute } from '@tanstack/react-router'
import { TaskPageLayout } from '../components/TaskPageLayout'
import { useSomedayTasks } from '../hooks/useSomedayTasks'
import { useTaskPageSetup } from '@/hooks'

export const Route = createFileRoute(
  '/_AppWrapper/_AppLayout/$workspaceSlug/tasks/someday',
)({
  component: SomedayPage,
})

/**
 * Someday tasks page component for long-term and backlog tasks.
 * 
 * Displays tasks that are marked as "someday" - items that don't have
 * specific due dates and represent future ideas, goals, or low-priority tasks.
 * This serves as a backlog or "maybe later" collection.
 * 
 * Features:
 * - Shows tasks marked with someday flag
 * - No specific due date requirements
 * - Full task management capabilities
 * - Subtask navigation support
 * - Hidden add task input (tasks added via other views)
 * 
 * Route: `/$workspaceSlug/tasks/someday`
 * 
 * @example
 * ```tsx
 * // Accessed via URL like: /my-workspace/tasks/someday
 * // Shows all tasks flagged as "someday" without due dates
 * ```
 */
function SomedayPage() {
  useTaskPageSetup()

  const { tasks, isLoading } = useSomedayTasks()

  return (
    <div className="flex h-full min-h-0 flex-col overflow-hidden">
      <TaskPageLayout
        tasks={tasks}
        isLoading={isLoading}
        defaultIsSomeday
        showAddTaskInput={false}
        pageTitle="Someday"
        navigateToSubtasks={true}
      />
    </div>
  )
}

export default SomedayPage
